// import React, { useState, useEffect } from 'react';
// import privateApi from "../../apis/privateApi";
// import Notification from "../../components/Notification/Notification";
// import ConfirmDialog from "../../components/ConfirmDialog/ConfirmDialog";
// import './BudgetCreate.css';
// import { useNavigate } from 'react-router-dom';

// const BudgetCreate = () => {

//     const navigate = useNavigate();

//     // -------------------------
//     // FORM STATE
//     // -------------------------
//     const [scope, setScope] = useState("state"); // 🔥 NEW
//     const [year, setYear] = useState('');
//     const [type, setType] = useState('Original');
//     const [remark, setRemark] = useState('');

//     const [stateId, setStateId] = useState('');
//     const [lgaId, setLgaId] = useState('');

//     const [states, setStates] = useState([]);
//     const [lgas, setLgas] = useState([]);

//     const [loading, setLoading] = useState(false);

//     const [notification, setNotification] = useState({
//         show: false,
//         message: '',
//         type: 'info'
//     });

//     const [confirmOpen, setConfirmOpen] = useState(false);
//     const [confirmToken, setConfirmToken] = useState('');
//     const [pendingSubmitData, setPendingSubmitData] = useState(null);

//     const currentYear = new Date().getFullYear();
//     const yearOptions = Array.from({ length: 5 }, (_, i) => currentYear - i);

//     const handleNotificationClose = () => {
//         setNotification(prev => ({ ...prev, show: false }));
//     };

//     const generateToken = () =>
//         Math.random().toString(36).substring(2, 8).toUpperCase();

//     // ---------------------------------------------
//     // FETCH STATES & LGAs
//     // ---------------------------------------------
//     useEffect(() => {
//         const fetchData = async () => {
//             try {
//                 const res = await privateApi.get(`/api/${scope}/budgets/locations`);

//                 if (scope === "state") {
//                     setStates(res.data.data || []);
//                     setLgas([]); // clear LGA
//                 } else {
//                     setLgas(res.data.data || []);
//                     setStates([]); // clear State
//                 }

//             } catch (err) {
//                 setNotification({
//                     show: true,
//                     message: `Failed to load ${scope === "state" ? "states" : "LGAs"}.`,
//                     type: "error"
//                 });
//             }
//         };

//         fetchData();
//     }, [scope]);

//     // ---------------------------------------------
//     // HANDLE SCOPE CHANGE
//     // ---------------------------------------------
//     const handleScopeChange = (value) => {
//         setScope(value);

//         // 🔥 Clear opposite selection
//         if (value === "state") {
//             setLgaId('');
//         } else {
//             setStateId('');
//         }
//     };

//     // ---------------------------------------------
//     // SUBMIT
//     // ---------------------------------------------
//     const handleSubmit = (e) => {
//         e.preventDefault();

//         if (scope === "state" && !stateId) {
//             return setNotification({ show: true, message: "Select a state", type: "error" });
//         }

//         if (scope === "lga" && !lgaId) {
//             return setNotification({ show: true, message: "Select an LGA", type: "error" });
//         }

//         const token = generateToken();
//         setConfirmToken(token);

//         setPendingSubmitData({
//             year,
//             type,
//             remark,
//             stateId,
//             lgaId,
//             scope
//         });

//         setConfirmOpen(true);
//     };

//     // ---------------------------------------------
//     // CONFIRM
//     // ---------------------------------------------
//     const handleConfirm = async (input) => {

//         if (input !== confirmToken) {
//             setNotification({
//                 show: true,
//                 message: 'Incorrect code entered. Action cancelled.',
//                 type: 'error'
//             });
//             setConfirmOpen(false);
//             return;
//         }

//         setConfirmOpen(false);
//         setLoading(true);

//         try {

//             const payload = {
//                 year: Number(pendingSubmitData.year),
//                 type: pendingSubmitData.type,
//                 remark: pendingSubmitData.remark
//             };

//             // 🔥 Attach correct ID only
//             if (pendingSubmitData.scope === "state") {
//                 payload.stateId = pendingSubmitData.stateId;
//             } else {
//                 payload.lgaId = pendingSubmitData.lgaId;
//             }

//             // 🔥 Use scope in URL instead of body
//             const res = await privateApi.post(`/api/${pendingSubmitData.scope}/budgets`, payload);

//             setNotification({
//                 show: true,
//                 message: `Budget ${res.data.data.type} ${res.data.data.year} rev ${res.data.data.revisionNumber} created successfully!`,
//                 type: 'success'
//             });

//             // RESET
//             setYear('');
//             setType('Original');
//             setRemark('');
//             setStateId('');
//             setLgaId('');

//         } catch (err) {
//             setNotification({
//                 show: true,
//                 message: err.response?.data?.message || 'Failed to create budget.',
//                 type: 'error'
//             });
//         } finally {
//             setLoading(false);
//             setPendingSubmitData(null);
//         }
//     };

//     const handleCancel = () => {
//         setConfirmOpen(false);
//         setPendingSubmitData(null);
//     };

//     return (
//         <div className="budgets-create">

//             <h2>Create Budget</h2>

//             <Notification {...notification} onClose={handleNotificationClose} />

//             <form onSubmit={handleSubmit}>

//                 {/* SCOPE */}
//                 <div className="budgets-create-form-group">
//                     <label>Budget Type</label>
//                     <select value={scope} onChange={(e) => handleScopeChange(e.target.value)}>
//                         <option value="state">State</option>
//                         <option value="lga">LGA</option>
//                     </select>
//                 </div>

//                 {/* STATE */}
//                 {scope === "state" && (
//                     <div className="budgets-create-form-group">
//                         <label>State</label>
//                         <select value={stateId} onChange={(e) => setStateId(e.target.value)} required>
//                             <option value="">Select State</option>
//                             {states.map(s => (
//                                 <option key={s._id} value={s._id}>{s.name}</option>
//                             ))}
//                         </select>
//                     </div>
//                 )}

//                 {/* LGA */}
//                 {scope === "lga" && (
//                     <div className="budgets-create-form-group">
//                         <label>LGA</label>
//                         <select value={lgaId} onChange={(e) => setLgaId(e.target.value)} required>
//                             <option value="">Select LGA</option>
//                             {lgas.map(l => (
//                                 <option key={l._id} value={l._id}>{l.name}</option>
//                             ))}
//                         </select>
//                     </div>
//                 )}

//                 {/* YEAR */}
//                 <div className="budgets-create-form-group">
//                     <label>Year</label>
//                     <select value={year} onChange={(e) => setYear(e.target.value)} required>
//                         <option value="">Select Year</option>
//                         {yearOptions.map(y => (
//                             <option key={y} value={y}>{y}</option>
//                         ))}
//                     </select>
//                 </div>

//                 {/* TYPE */}
//                 <div className="budgets-create-form-group">
//                     <label>Type</label>
//                     <select value={type} onChange={(e) => setType(e.target.value)}>
//                         <option value="Original">Original</option>
//                         <option value="Supplementary">Supplementary</option>
//                     </select>
//                 </div>

//                 {/* REMARK */}
//                 <div className="budgets-create-form-group">
//                     <label>Remark</label>
//                     <textarea
//                         value={remark}
//                         onChange={(e) => setRemark(e.target.value)}
//                         placeholder="Optional remark..."
//                     />
//                 </div>

//                 {/* ACTIONS */}
//                 <div className="budgets-create-action-buttons">
//                     <button className='budgets-create-btn' type="submit" disabled={loading}>
//                         {loading ? 'Creating...' : 'Create Budget'}
//                     </button>

//                     <button className='budgets-create-back-btn' type="button" onClick={() => navigate(-1)}>
//                         Back
//                     </button>
//                 </div>

//             </form>

//             <ConfirmDialog
//                 show={confirmOpen}
//                 token={confirmToken}
//                 action={`You are about to create a ${type} ${scope} budget for ${year}`}
//                 onConfirm={handleConfirm}
//                 onCancel={handleCancel}
//             />

//         </div>
//     );
// };

// export default BudgetCreate;

import React, { useState, useEffect } from 'react';
import privateApi from '../../apis/privateApi';
import Notification from '../../components/Notification/Notification';
import ConfirmDialog from '../../components/ConfirmDialog/ConfirmDialog';
import { useNavigate } from 'react-router-dom';
import './BudgetCreate.css';

const BudgetCreate = () => {
    const navigate = useNavigate();

    const [scope, setScope] = useState('state');
    const [year, setYear] = useState('');
    const [type, setType] = useState('Original');
    const [remark, setRemark] = useState('');
    const [stateId, setStateId] = useState('');
    const [lgaId, setLgaId] = useState('');
    const [states, setStates] = useState([]);
    const [lgas, setLgas] = useState([]);
    const [loading, setLoading] = useState(false);

    const [notification, setNotification] = useState({ show: false, message: '', type: 'info' });
    const [confirmOpen, setConfirmOpen] = useState(false);
    const [confirmToken, setConfirmToken] = useState('');
    const [pendingSubmitData, setPendingSubmitData] = useState(null);

    const currentYear = new Date().getFullYear();
    const yearOptions = Array.from({ length: 5 }, (_, i) => currentYear - i);

    useEffect(() => {
        (async () => {
            try {
                const res = await privateApi.get(`/api/${scope}/budgets/locations`);
                if (scope === 'state') { setStates(res.data.data || []); setLgas([]); }
                else { setLgas(res.data.data || []); setStates([]); }
            } catch {
                setNotification({ show: true, message: `Failed to load ${scope === 'state' ? 'states' : 'LGAs'}.`, type: 'error' });
            }
        })();
    }, [scope]);

    const handleScopeChange = v => {
        setScope(v);
        if (v === 'state') setLgaId(''); else setStateId('');
    };

    const handleSubmit = e => {
        e.preventDefault();
        if (scope === 'state' && !stateId) return setNotification({ show: true, message: 'Select a state', type: 'error' });
        if (scope === 'lga' && !lgaId) return setNotification({ show: true, message: 'Select an LGA', type: 'error' });
        const token = Math.random().toString(36).substring(2, 8).toUpperCase();
        setConfirmToken(token);
        setPendingSubmitData({ year, type, remark, stateId, lgaId, scope });
        setConfirmOpen(true);
    };

    const handleConfirm = async input => {
        if (input !== confirmToken) {
            setNotification({ show: true, message: 'Incorrect code entered. Action cancelled.', type: 'error' });
            setConfirmOpen(false);
            return;
        }
        setConfirmOpen(false);
        setLoading(true);
        try {
            const payload = {
                year: Number(pendingSubmitData.year),
                type: pendingSubmitData.type,
                remark: pendingSubmitData.remark,
            };
            if (pendingSubmitData.scope === 'state') payload.stateId = pendingSubmitData.stateId;
            else payload.lgaId = pendingSubmitData.lgaId;

            const res = await privateApi.post(`/api/${pendingSubmitData.scope}/budgets`, payload);
            setNotification({
                show: true,
                message: `Budget ${res.data.data.type} ${res.data.data.year} rev ${res.data.data.revisionNumber} created successfully!`,
                type: 'success',
            });
            setYear(''); setType('Original'); setRemark(''); setStateId(''); setLgaId('');
            setTimeout(() => {
                navigate(-1);
            }, 2000);
        } catch (err) {
            setNotification({ show: true, message: err.response?.data?.message || 'Failed to create budget.', type: 'error' });
        } finally {
            setLoading(false);
            setPendingSubmitData(null);
        }
    };

    return (
        <div className="bgt-page-centered">
            <div style={{ width: '100%', maxWidth: 520 }}>

                {/* Notification outside card so it isn't clipped */}
                <Notification show={notification.show} message={notification.message}
                    type={notification.type} onClose={() => setNotification(p => ({ ...p, show: false }))} />

                <div className="bgt-card" style={{ animation: 'bgt-fadeUp .45s ease both' }}>
                    {/* Header */}
                    <div className="bgt-card-header">
                        <h2>Create Budget</h2>
                        <p>Define a new fiscal budget for a state or LGA</p>
                    </div>

                    {/* Form */}
                    <form className="bgt-form-body" onSubmit={handleSubmit}>
                        <div className="bgt-section-title">Scope &amp; Location</div>

                        {/* Budget scope */}
                        <div className="bgt-form-group">
                            <label className="bgt-label required">Budget Level</label>
                            <select className="bgt-select" value={scope} onChange={e => handleScopeChange(e.target.value)}>
                                <option value="state">State</option>
                                <option value="lga">LGA</option>
                            </select>
                        </div>

                        {/* State */}
                        {scope === 'state' && (
                            <div className="bgt-form-group">
                                <label className="bgt-label required">State</label>
                                <select className="bgt-select" value={stateId}
                                    onChange={e => setStateId(e.target.value)} required>
                                    <option value="">Select State…</option>
                                    {states.map(s => <option key={s._id} value={s._id}>{s.name}</option>)}
                                </select>
                            </div>
                        )}

                        {/* LGA */}
                        {scope === 'lga' && (
                            <div className="bgt-form-group">
                                <label className="bgt-label required">LGA</label>
                                <select className="bgt-select" value={lgaId}
                                    onChange={e => setLgaId(e.target.value)} required>
                                    <option value="">Select LGA…</option>
                                    {lgas.map(l => <option key={l._id} value={l._id}>{l.name}</option>)}
                                </select>
                            </div>
                        )}

                        <div className="bgt-form-divider" />
                        <div className="bgt-section-title">Budget Details</div>

                        {/* Year */}
                        <div className="bgt-form-group">
                            <label className="bgt-label required">Fiscal Year</label>
                            <select className="bgt-select" value={year}
                                onChange={e => setYear(e.target.value)} required>
                                <option value="">Select Year…</option>
                                {yearOptions.map(y => <option key={y} value={y}>{y}</option>)}
                            </select>
                        </div>

                        {/* Type */}
                        <div className="bgt-form-group">
                            <label className="bgt-label">Budget Type</label>
                            <select className="bgt-select" value={type} onChange={e => setType(e.target.value)}>
                                <option value="Original">Original</option>
                                <option value="Supplementary">Supplementary</option>
                            </select>
                        </div>

                        {/* Remark */}
                        <div className="bgt-form-group">
                            <label className="bgt-label">Remark</label>
                            <textarea className="bgt-textarea" value={remark}
                                onChange={e => setRemark(e.target.value)}
                                placeholder="Optional remark…" />
                        </div>

                        <div className="bgt-form-actions">
                            <button type="button" className="bgt-btn bgt-btn-secondary" onClick={() => navigate(-1)}>
                                ← Back
                            </button>
                            <button type="submit" className="bgt-btn bgt-btn-primary" disabled={loading}>
                                {loading ? 'Creating…' : '✓ Create Budget'}
                            </button>
                        </div>
                    </form>
                </div>
            </div>

            <ConfirmDialog show={confirmOpen} token={confirmToken}
                action={`You are about to create a ${type} ${scope} budget for ${year}`}
                onConfirm={handleConfirm}
                onCancel={() => { setConfirmOpen(false); setPendingSubmitData(null); }} />
        </div>
    );
};

export default BudgetCreate;
